import { Component, OnInit } from '@angular/core';
import { LeagueService } from '../services/league.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ConfirmDeleteComponent } from '../dialog/confirm-delete/confirm-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-leagues',
  templateUrl: './leagues.component.html',
  styleUrls: ['./leagues.component.css']
})
export class LeaguesComponent implements OnInit {

  leagues: League[] = [];
  loading = true;
  err = '';
  playerUri = environment.playerUri;
  leagueToEdit: League | null = null;
  isSavingModal = false;

  constructor(private leagueService: LeagueService, private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getLeagueList()
  }

  getLeagueList() {
    this.loading = true;
    this.err = '';
    this.leagueService.getLeagueList()
    .pipe(finalize(() => this.loading = false))
    .subscribe(
      (leagues: League[]) => {
        this.leagues = leagues;
        this.leagues.sort((a, b) => a.league_start > b.league_start ? -1 : 1);
        this.leagues.forEach(league => {
          league.status = this.leagueStatus(league);
        });
      },
      err => this.err = err.error.detail
    );
  }

  goToNewLeague() {
    this.router.navigate(['/leagues/new']);
  }

  isLocal(league: League) {
    if (league.league_venues.length) return true;
    if (league.state) return true;
    if (league.latitude && league.longitude && league.distance > 0) return true;
    return false;
  }

  scoreType(league: League) {
    if (league.scoring_type === 'total_score') return 'Sum of Scores';
    if (league.scoring_type === 'total_tba') return 'Sum of TBAs';
    if (league.scoring_type === 'average_score') return 'Average Scores';
    if (league.scoring_type === 'average_tba') return 'Average TBA';
    return 'Unknown';
  }

  leagueStatus(league: League) {
    if (league.finalized) return 'Finalized';
    if (league.league_end < new Date().toISOString()) return 'Completed';
    if (league.league_start > new Date().toISOString()) return 'Not Started';
    return 'In Progress';
  }

  confirmDeleteLeague(league: League) {
    console.log(league);
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      data: {
        title: `Really delete ${league.league_name}?`,
        content: 'This action cannot be undone.'
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteLeague(league.leagueid);
      }
    });
  }

  deleteLeague(leagueid: string) {
    this.loading = true;
    this.err = '';
    this.leagueService.deleteLeague(leagueid)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        (res: boolean) => {
          this.getLeagueList();
        },
        err => this.err = err.error.detail
      );
  }

  startEditLeague(league: League) {
    this.leagueToEdit = league;
  }

  cancelEditLeague() {
    this.leagueToEdit = null;
  }

  updateLeague(updateLeague: NewLeague) {
    this.loading = true;
    this.err = '';
    this.leagueService.updateLeague(this.leagueToEdit.kt_league_id, updateLeague)
      .subscribe(
        (res: League) => {
          this.cancelEditLeague();
          this.getLeagueList();
        },
        (err) => {
          this.err = err.error.detail;
          this.loading = false;
        });
  }

}
